import Vue from 'vue'
import App from './App.vue'
import router from "@/router";
import ElementUI from 'element-ui';
import 'lib-flexible'
import {fileView} from '@/common/api.js'
import 'element-ui/lib/theme-chalk/index.css';
import '@/common/global.css';

// import Vant from 'vant';
// import 'vant/lib/index.css';
// Vue.use(Vant);

// import infiniteScroll from 'vue-infinite-scroll'
// Vue.use(infiniteScroll)
// main.js 或 main.ts 中执行一次
// function setHtmlFontSize() {
//   const vw = document.documentElement.clientWidth;
//   // 以大屏 1920px 为基准：htmlFontSize = 当前宽度 / 10
//   // 如果你想以移动稿 375px 为基准，也可以改成 vw / 3.75
//   const fontSize = vw / 10;
//   document.documentElement.style.fontSize = fontSize + 'px';
// }
// // 首次执行
// setHtmlFontSize();
// // 窗口宽度发生变化时，重新计算
// window.addEventListener('resize', setHtmlFontSize);

// 假设设计稿为1920px
const baseSize = 16
// // 根据设计稿调整（设计稿宽度/10）
function setRemUnit() {
  const scale = document.documentElement.clientWidth / 1920
  const fontSize = baseSize * Math.min(scale, 2) > 12 ? baseSize * Math.min(scale, 2) : 12
  document.documentElement.style.fontSize = `${fontSize}px`

  // window.location.reload();

}

setRemUnit()
window.onresize = ()=>{
  setRemUnit()
  setTimeout(()=>{
    window.location.reload();
  },500);
}

window.addEventListener('beforeunload', function (e) {
  window.localStorage.removeItem('activePath');
  window.localStorage.setItem('activePath','/admin/overview');
});



Vue.config.productionTip = false
Vue.use(ElementUI)

import {get,post,postFile} from './common/request'
Vue.prototype.$httpGet = get
Vue.prototype.$httpPost = post
Vue.prototype.$postFile = postFile

Vue.prototype.$getImageSrc = function(img) {
  return fileView + '?id=' + img;
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
